// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","lg":"992px","container":"ClosedSocialLayout_container__3XTvE"};